module.exports = __webpack_public_path__ + "img/logo_text_only.97219695.svg";